import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useFetcher } from 'react-router'
import { useRemixForm } from 'remix-hook-form'
import { toast } from 'sonner'
import {
	type action,
	type ContactUsData,
	ContactUsSchema,
} from '#app/routes/_marketing+/kontakt.tsx'

import { useOptionalUser } from '#app/utils/user.ts'
import { Form, FormActions } from '../form/form'
import { FormStatusButton } from '../form/form-status-button'
import { TextField } from '../form/text-field'
import { TextareaField } from '../form/textarea-field'
import { Button } from '../ui/button'
import { DialogClose } from '../ui/dialog'
const resolver = zodResolver(ContactUsSchema)

export function ContactUsForm({
	setOpen,
	showCancel = true,
}: {
	setOpen: (open: boolean) => void
	showCancel?: boolean
}) {
	const fetcher = useFetcher<typeof action>()
	const user = useOptionalUser()
	const { name, email } = user ?? {}
	const methods = useRemixForm<ContactUsData>({
		mode: 'onTouched',
		resolver,
		fetcher,
		defaultValues: {
			name: name ?? '',
			email: email ?? '',
		},
		submitConfig: {
			action: '/kontakt',
			method: 'POST',
			navigate: false,
		},
	})

	const { reset } = methods

	useEffect(() => {
		if (fetcher.data?.response) {
			toast.success('Nachricht erfolgreich gesendet!')
			reset()
			setOpen(false)
		}
		if (fetcher.data?.error) {
			toast.error(
				'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.',
			)
		}
	}, [reset, fetcher.data, setOpen])

	return (
		<Form
			methods={methods}
			action="/contact-us"
			className="mt-6 flex flex-col space-y-6 text-left"
			navigate={false}
		>
			<TextField name="name" label="Name" layout={'stacked'} />
			<TextField name="email" label="E-Mail" layout={'stacked'} />
			<TextField name="subject" label="Betreff" layout={'stacked'} />
			<TextareaField name="message" label="Nachricht" layout={'stacked'} />
			<FormActions>
				{showCancel && (
					<Button
						type="button"
						variant={'secondary'}
						onClick={() => setOpen(false)}
					>
						Abbrechen
					</Button>
				)}
				<FormStatusButton type="submit" className="bg-pcteal-default grow">
					Absenden
				</FormStatusButton>
			</FormActions>
		</Form>
	)
}
